// extracted by mini-css-extract-plugin
export default {"Modal":"VersionErrorModal_Modal__FqfZ7","Buttons":"VersionErrorModal_Buttons__-rvn8"};